This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div class="basicBlock">
    <p class="header upper">{{ $t("profile.classroomBlockHeader") }}</p>
    <ul>
      <li
        class="blockEntry"
        v-for="classroom in classrooms"
        :key="classroom.classroomId"
      >
        {{ classroom.name }}
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { classAPI } from "@/utils/apiCalls";

@Options({
  data() {
    return {
      classrooms: [],
    };
  },
  async mounted() {
    //Get users classes
    this.classrooms = await classAPI.getMyClassrooms();
  },
})
export default class ClassroomsOverviewBlock extends Vue {}
</script>
